// AdvancedFilterPopover.js
import { useEffect } from "react";
import { Popover } from "antd";
import { FormattedMessage } from "react-intl";
import { FilterIcon, FilterIconLight } from "./../../../utility/icons/index";
import { CustomButton } from "./../../../utility/CustomButton";

const AdvancedFilterPopover = ({
  trigger,
  visible,
  onVisibleChange,
  content,
  onClear,
  onApply,
  placement,
  overlayClassName,
  contentWidth,
  zIndex,
  btnContainerStyle,
  applyButtonStyle,
  clearButtonStyle,
  fromCtrlQ,
  showFilters,
  title,
  actionsPlacement = "header",
  showClose = false,
  applyLabel = "Apply Filters",
  buttonLabel = "Advance Filters",
}) => {
  const filterTitle = title || "Advance Filters";
  const filterContentWidth = contentWidth ? `${contentWidth}px` : "516px";

  useEffect(() => {
    if (!visible) return undefined;

    const closeOnPageScroll = (event) => {
      if (event.target?.closest?.(".ant-popover, .ant-dropdown, .ant-select-dropdown, .ant-picker-dropdown")) return;
      onVisibleChange?.(false);
    };
    window.addEventListener("scroll", closeOnPageScroll, true);

    return () => window.removeEventListener("scroll", closeOnPageScroll, true);
  }, [visible, onVisibleChange]);

  const actions = (
      <div className={btnContainerStyle ? `${btnContainerStyle} advanced-filter-popover-actions` : "stocks-btn-conatiner advanced-filter-popover-actions"}>
        <button type="button" className={clearButtonStyle ? clearButtonStyle : "clear-btn-stock"} onClick={onClear}>
          <FormattedMessage id="Clear Filters" defaultMessage="Clear Filters" />
        </button>
        <button type="button" className={applyButtonStyle ? applyButtonStyle : "btn-stock"} onClick={onApply}>
          <FormattedMessage id={applyLabel} defaultMessage={applyLabel} />
        </button>
      </div>
  );

  const popoverTitle = (
    <div className="advanced-filter-popover-header">
      <span>{filterTitle}</span>
      {actionsPlacement === "header" && actions}
      {showClose && (
        <button type="button" className="advanced-filter-popover-close" aria-label="Close advance filters" onClick={() => onVisibleChange?.(false)}>
          <span aria-hidden="true">×</span>
        </button>
      )}
    </div>
  );

  return (
    <Popover
      placement={placement}
      zIndex={zIndex}
      getPopupContainer={(trigger) => (!fromCtrlQ ? document.body : trigger.parentElement || document.body)}
      title={popoverTitle}
      overlayClassName={overlayClassName}
      content={<div style={{ width: filterContentWidth, maxWidth: "100%" }}>
        {content}
        {actionsPlacement === "footer" && <div className="advanced-filter-popover-footer">{actions}</div>}
      </div>}
      trigger={trigger}
      visible={visible}
      onVisibleChange={onVisibleChange}
    >
      <CustomButton
        label={buttonLabel}
        Icon={showFilters ? FilterIconLight : FilterIcon}
        className={showFilters ? (fromCtrlQ ? "advance-filter-selected-btn-from-ctrlQ" : "advance-filter-selected-btn") : "advance-filter-btn"}
        iconPosition="before"
      />
    </Popover>
  );
};

export default AdvancedFilterPopover;
